import { ETableActionType, ITableKey } from "src/app/modules/shared/components/basic-table/basic-table.constants";

export interface IDocumentsModulesResponse {
    athoraFiles?: IDocumentModule[];
    intesaFiles?: IDocumentModule[];
    previdenzaFiles?: IDocumentModule[];
}
export interface IDocumentModule {
    preSignedUrl: string;
    name: string;
}

export const documents_table_keys: ITableKey[] = [
    {
        key: 'name',
        label: 'Documento'
    },
    {
        key: ETableActionType.DOWNLOAD,
        label: '',
        type: 'ACTION_ICON',
        actionIcon: 'download',
        color: 'primary',
        showIconFieldName: 'showIcon'
    }
]
